/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import optionSelect, {
    disabledContainerClassName,
    optionInputSelector,
    selectedContainerSelector
} from "./mixins/option-select";

const componentName = "category-options";
const nativeSelectSelector = "select[name='category']";

export default baustein.register(componentName, {
    mixins: [optionSelect],

    setupEvents(add) {
        add("click", optionInputSelector, this.emitCategoryChangedEvent);
        add("change", nativeSelectSelector, this.emitCategoryChangedEvent);
    },

    emitCategoryChangedEvent(event) {
        this.emit("categoryChanged", { selectedCategory: event.target.value || null });
    },

    onInsert() {
        this.disableIfNull();
    },

    /**
     * Disable category options if no product type is selected
     */
    disableIfNull() {
        const selectedOption = this.options.currentOptions.find(option => {
            return option["checked"] === true;
        }).value;

        if (selectedOption === null) {
            this.el
                .querySelector(selectedContainerSelector)
                .classList.add(disabledContainerClassName);
            this.el.querySelector(nativeSelectSelector).disabled = true;
        }
    },

    updateCategoryOptions(
        taxonomyMap,
        targetGender,
        targetProductType,
        selectedCategory = undefined
    ) {
        let newOptions = taxonomyMap[targetGender][targetProductType]["children"];

        let newLabel = "";
        newOptions.forEach(option => {
            if (selectedCategory) {
                option["checked"] = option["value"] === selectedCategory;
            } else {
                // If no category is selected, we then either check the
                // `All [product type]` option, or the `All` option
                // These 2 options are mutually exclusive
                const isAllProductTypeOption = option["value"] === "";
                const isAllOption = option["value"] === null;
                option["checked"] = isAllProductTypeOption || isAllOption;
            }

            if (option["checked"]) {
                newLabel = option["label"];
            }
        });

        let context = this.getRenderContext();
        context.option_select.current_options = newOptions;
        context.option_select.selected_option_label = newLabel;
        context.option_select.column_count = Math.ceil(newOptions.length / 5);
        this.updateOptions(
            Object.assign({}, this.options, {
                currentOptions: newOptions
            })
        );
        this.setRenderContext(context);
        this.disableIfNull();
    }
});

